<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="物流日志详情" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="车号">{{ mdl.vehicleNo }}</detail-list-item>
        <detail-list-item term="物流状态">{{ mdl.statusName }}</detail-list-item>
        <detail-list-item term="业务类型">{{ mdl.businessTypeName }}</detail-list-item>
        <detail-list-item term="创建时间">{{mdl.createTime | formatDate}}</detail-list-item>
        <!--<detail-list-item term="请求参数">{{ mdl.parameters }}</detail-list-item>-->
      </detail-list>
      <detail-list  v-if="mdl">
        <detail-list-item term="请求参数">{{ mdl.parameters }}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"

const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-logisticsLogDetail")
      if (cache){
          this.mdl = JSON.parse(cache);
      } 
    }
  }
}
</script>



